import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../store/configureStore';
import { ApiRequestStatus } from '../enums/apiRequestStatus';
import { getCanReEnrolAsync } from '../slices/pcsSlice';

export const useCanReEnrol = (reenrol: boolean) => {
    const dispatch = useAppDispatch();
    const { canReEnrol, canReEnrolStatus } = useAppSelector(state => state.pcs);

    useEffect(() => {
        if (reenrol === true && canReEnrol === null && canReEnrolStatus === ApiRequestStatus.Idle) {
            dispatch(getCanReEnrolAsync());
        }
    }, [canReEnrol, canReEnrolStatus, dispatch]);

    return { canReEnrolStatus };
};
